// extracted by mini-css-extract-plugin
export default {"tx":"_13886bef5a","line":"f052bea388"};